<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.name" placeholder="学校名称" style="width: 230px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.schoolCode" placeholder="学校码" style="width: 230px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="info" plain @click="setAssociation">校友会</el-button>
                <el-button type="info" plain @click="setSchool">学校设置</el-button>
                <el-button type="primary" plain @click="setAddSchool" v-if="isAdmin">添加学校</el-button>
            </div>

            <el-table
                :data="depts"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                row-key="id"
                border
                lazy
                :load="load">
                <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column>
                <el-table-column prop="name" label="学校名称"></el-table-column>
                <el-table-column prop="schoolCode" width="100px" label="学校码"></el-table-column>
                <el-table-column width="220px" label="第三方编码">
                    <template slot-scope="scope">
                        {{ formatPlateformCodeCell(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.nature == 1">
                            幼儿园
                        </div>
                        <div v-else-if="scope.row.nature == 2">
                            小学
                        </div>
                        <div v-else-if="scope.row.nature == 3">
                            中学
                        </div>
                        <div v-else-if="scope.row.nature == 0">
                            其他
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bindDeptNames" label="关联学校" width="200px"></el-table-column>
                <el-table-column prop="deptControllerName" label="学校负责人" width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-dropdown trigger="click" @command="(cmd) => handleMoreCommand(cmd, scope.row)">
                            <span class="el-dropdown-link" style="color: #387EE8;cursor: pointer;">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="setSchoolDept">设置学校组织</el-dropdown-item>
                                <el-dropdown-item command="generatorSchoolCode" v-if="scope.row.schoolCode == null">生成学校码</el-dropdown-item>
                                <el-dropdown-item command="setBindSchool" v-if="isAdmin">设置关联学校</el-dropdown-item>
                                <el-dropdown-item command="setPlateformCode" v-if="isAdmin">设置第三方编码</el-dropdown-item>
                                <el-dropdown-item command="viewThirdSyncRecord" v-if="isAdmin">查看同步第三方记录</el-dropdown-item>
                                <el-dropdown-item command="syncToThirdPlatform" v-if="isAdmin">同步数据到第三方</el-dropdown-item>
                                <el-dropdown-item command="clearThirdPlatformData" v-if="isAdmin">清空第三方数据</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-button  @click.native.prevent="delBySchoolId(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 设置学校组织弹出框 -->
        <div v-if="setSchoolDeptVisible">
            <setSchoolDept ref="setSchoolDept"></setSchoolDept>
        </div>
        <!-- 设置绑定学校弹出框 -->
        <div v-if="setBindSchoolVisible">
            <setBindSchool ref="setBindSchool"></setBindSchool>
        </div>
        <!-- 修改弹出框 -->
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- 添加学校弹出框 -->
        <div v-if="addSchoolVisible">
            <addSchool ref="addSchool"></addSchool>
        </div>
        <!-- 学校设置弹出框 -->
        <div v-if="setSchoolMainVisible">
            <setSchoolMain ref="setSchoolMain"></setSchoolMain>
        </div>
        <!-- 校友会弹出框 -->
        <div v-if="associationVisible">
            <association ref="association"></association>
        </div>

        <!-- 查看同步第三方记录弹出框 -->
        <div v-if="thirdSyncRecordVisible">
            <thirdSyncRecord ref="thirdSyncRecord" @closed="thirdSyncRecordVisible=false"></thirdSyncRecord>
        </div>

        <!-- 设置第三方编码弹出框 -->
        <el-dialog title="设置第三方编码" :close-on-click-modal="false" :visible.sync="plateformCodeVisible" width="380px">
            <el-form ref="plateformCodeForm" :model="plateformCodeForm" :rules="plateformCodeFormRules" label-width="100px">
                <el-form-item label="学校名称">
                    <el-input v-model="plateformCodeForm.name" :readonly="true" style="width: 220px;"></el-input>
                </el-form-item>
                <el-form-item label="第三方编码">
                    <el-input v-model="plateformCodeForm.plateformCode" maxlength="100" clearable style="width: 220px;"></el-input>
                </el-form-item>
                <el-form-item label="会员类型" prop="memberType">
                    <el-select v-model="plateformCodeForm.memberType" placeholder="请选择会员类型" style="width: 220px;">
                        <el-option :value="1" label="VIP/SVIP"></el-option>
                        <el-option :value="2" label="BVIP"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="plateformCodeVisible=false">取消</el-button>
                <el-button type="primary" @click="savePlateformCode()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import addSchool from './addSchool.vue'; 
    import setSchoolDept from './SetSchoolDept.vue';
    import setBindSchool from './SetBindSchool.vue'; 
    import update from './Update.vue'; 
    import setSchoolMain from './SetSchoolMain.vue'; 
    import association from './association/List.vue';
    import thirdSyncRecord from './ThirdSyncRecord.vue';

    export default {
        name:"Dept",
        data(){
            return{
                loading: false,
                loadingText: "",
                menuName:"",
                setSchoolDeptVisible:false,
                addSchoolVisible:false,
                updateVisible:false,
                setSchoolMainVisible:false,
                associationVisible:false,
                setBindSchoolVisible:false,
                plateformCodeVisible:false,
                thirdSyncRecordVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                queryForm:{
                    name: "",
                    schoolCode: ""
                },
                form:{
                    id:""
                },
                plateformCodeForm:{
                    id:"",
                    name:"",
                    plateformCode:"",
                    memberType: null
                },
                plateformCodeFormRules:{
                    memberType: [
                        { required: true, message: '请选择会员类型', trigger: 'change' }
                    ]
                },
                depts:[],
                isAdmin: false,
            }
        },
        components: {
            setSchoolDept, setBindSchool, update, addSchool, setSchoolMain, association, thirdSyncRecord
        },
        created:function () {
            this.getData()
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'))
            // 如果id为1的话，表示管理员，管理才能设置公共参数
            if(userinfo.id == 1){
                this.isAdmin=true
            }else{
                this.isAdmin=false
            }
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            formatPlateformCodeCell(row) {
                const code = row.plateformCode;
                if (!this.$util.isNotEmpty(code)) {
                    return '';
                }
                const t = row.memberType;
                let typeLabel = '';
                if (t === 1 || t === '1') {
                    typeLabel = 'VIP/SVIP';
                } else if (t === 2 || t === '2') {
                    typeLabel = 'BVIP';
                }
                return typeLabel ? (code + '（' + typeLabel + '）') : code;
            },
            selectable(row){
                return true
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中..."

                let url  = this.deptGetSchoolListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.queryForm.name,
                    schoolCode: this.queryForm.schoolCode
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res.status == 200){
                       this.depts = res.data.data
                       this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 设置学校组织
            setSchoolDept(data){
                this.setSchoolDeptVisible = true
                this.$nextTick(() => {
                    this.$refs['setSchoolDept'].init(data)
                })
            },
            // 设置关联学校
            setBindSchool(data){
                this.setBindSchoolVisible = true
                this.$nextTick(() => {
                    this.$refs['setBindSchool'].init(data)
                })
            },
            // 生成学校码
            generatorSchoolCode(data){
                this.loading=true;
                this.loadingText="数据生成中..."

                let url  = this.deptGeneratorSchoolCodeUrl
                let reqData = {
                    id: data.id,
                };
                this.apiPost(url,reqData).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleMoreCommand(cmd,row){
                if(cmd === 'setSchoolDept'){
                    this.setSchoolDept(row);
                }else if(cmd === 'generatorSchoolCode'){
                    this.generatorSchoolCode(row);
                }else if(cmd === 'setBindSchool'){
                    if (!this.isAdmin) return;
                    this.setBindSchool(row);
                }else if(cmd === 'setPlateformCode'){
                    if (!this.isAdmin) return;
                    this.setPlateformCode(row);
                }else if(cmd === 'viewThirdSyncRecord'){
                    this.viewThirdSyncRecord(row);
                }else if(cmd === 'syncToThirdPlatform'){
                    this.syncToThirdPlatform(row);
                }else if(cmd === 'clearThirdPlatformData'){
                    this.clearThirdPlatformData(row);
                }
            },
            syncToThirdPlatform(row){
                if(!this.$util.isNotEmpty(row.plateformCode)){
                    this.$commonFn.showTip('请先设置第三方编码后再同步', 3);
                    return;
                }
                const msg = '同步数据到第三方耗时较长，期间请勿关闭或刷新页面，是否继续？';
                this.$commonFn.showConfirm2(msg, () => {
                    this.doSyncToThirdPlatform(row);
                });
            },
            doSyncToThirdPlatform(row){
                const loadingInstance = this.$loading({
                    lock: true,
                    fullscreen: true,
                    text: '正在同步数据到第三方，请耐心等待，请勿关闭页面…',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const url = this.deptSyncToThirdPlatformUrl;
                const data = {
                    id: row.id,
                    sid: row.plateformCode
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message, 1);
                    }else{
                        this.$commonFn.showTip(res.message, 3);
                    }
                    loadingInstance.close();
                }, (err) => {
                    console.log(err);
                    loadingInstance.close();
                });
            },
            clearThirdPlatformData(row){
                const msg = '清空【' + row.name + '】第三方数据过程会较久，期间请勿关闭或刷新页面，是否继续？';
                this.$commonFn.showConfirm2(msg, () => {
                    this.doClearThirdPlatformData(row);
                });
            },
            doClearThirdPlatformData(row){
                const loadingInstance = this.$loading({
                    lock: true,
                    fullscreen: true,
                    text: '正在清空第三方数据，请耐心等待，请勿关闭页面…',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const url = this.deptClearThirdPlatformDataUrl;
                const data = { deptId: row.id };
                this.apiPost(url, data).then((res) => {
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message, 1);
                    }else{
                        this.$commonFn.showTip(res.message, 3);
                    }
                    loadingInstance.close();
                }, (err) => {
                    console.log(err);
                    loadingInstance.close();
                });
            },
            viewThirdSyncRecord(row){
                this.thirdSyncRecordVisible = true;
                this.$nextTick(() => {
                    this.$refs['thirdSyncRecord'].init(row);
                })
            },
            // 设置第三方编码
            setPlateformCode(data){
                this.plateformCodeForm.id = data.id;
                this.plateformCodeForm.name = data.name;
                this.plateformCodeForm.plateformCode = this.$util.isNotEmpty(data.plateformCode) ? data.plateformCode : "";
                const mt = data.memberType;
                this.plateformCodeForm.memberType = (mt === 1 || mt === 2 || mt === '1' || mt === '2') ? Number(mt) : null;
                this.plateformCodeVisible = true;
                this.$nextTick(() => {
                    if (this.$refs.plateformCodeForm) {
                        this.$refs.plateformCodeForm.clearValidate();
                    }
                });
            },
            savePlateformCode(){
                this.$refs['plateformCodeForm'].validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    let url = this.deptSetPlateformCodeUrl;
                    const mt = this.plateformCodeForm.memberType;
                    let data = {
                        id: this.plateformCodeForm.id,
                        plateformCode: this.plateformCodeForm.plateformCode,
                        memberType: mt
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status == 200){
                            this.$commonFn.showTip(res.message,1);
                            this.plateformCodeVisible = false;
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err)
                    });
                });
            },
            //新增学校界面
            setAddSchool(){
                this.addSchoolVisible = true
                this.$nextTick(() => {
                    this.$refs['addSchool'].init()
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            delBySchoolId(data){
                this.form.id = data.id
                let msg="删除【"+data.name+"】学校操作，会与该学校相关数据全部清空，是否继续？"
                this.$commonFn.showConfirm2(msg,this.delBySchoolIdSuccess)
            },
            delBySchoolIdSuccess(){
                this.loading=true
                this.loadingText="数据删除中..."

                let url = this.deptRemoveBySchoolIdUrl
                let data = {
                    'schoolId': this.form.id
                };
                // console.log('delBySchoolId',data)
                // return
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1)
                        this.common.page = 1
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                    this.loading=false
                })
            },
            setSchool(){ // 学校设置
                this.setSchoolMainVisible=true
                this.$nextTick(() => {
                    this.$refs['setSchoolMain'].init()
                })
            },
            setAssociation(){ // 校友会
                this.associationVisible=true
                this.$nextTick(() => {
                    this.$refs['association'].init()
                })
            },
            load(tree, treeNode, resolve) {
                console.log('加载数据...')
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>



// WEBPACK FOOTER //
// src/components/page/sys/dept/Dept.vue